import { render, staticRenderFns } from "./Paypassword.vue?vue&type=template&id=a4e2ff10&scoped=true&"
import script from "./Paypassword.vue?vue&type=script&lang=js&"
export * from "./Paypassword.vue?vue&type=script&lang=js&"
import style0 from "./Paypassword.vue?vue&type=style&index=0&id=a4e2ff10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e2ff10",
  null
  
)

export default component.exports